import React from 'react';

const TermsPage = () => {
  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px'
    },
    title: {
      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
      color: '#1a1a2e',
      marginBottom: '10px'
    },
    date: {
      color: '#666',
      marginBottom: '30px'
    },
    section: {
      marginBottom: '30px'
    },
    heading: {
      fontSize: '1.3rem',
      color: '#1a1a2e',
      marginBottom: '15px'
    },
    text: {
      color: '#555',
      lineHeight: 1.7,
      marginBottom: '15px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Terms of Service</h1>
      <p style={styles.date}>Last Updated: January 2026</p>

      <div style={styles.section}>
        <h2 style={styles.heading}>1. Acceptance of Terms</h2>
        <p style={styles.text}>
          By accessing or using Rx.ChatWithDr.com ("Service"), you agree to be bound by these Terms of Service. 
          If you do not agree to these terms, please do not use our Service.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>2. Description of Service</h2>
        <p style={styles.text}>
          Rx.ChatWithDr.com provides a prescription discount card program that helps users find discounted 
          prices on prescription medications at participating pharmacies. Our Service includes drug price 
          comparison, digital discount card generation, and pharmacy location services.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>3. Not Insurance</h2>
        <p style={styles.text}>
          The Rx.ChatWithDr discount card is NOT insurance. It is a discount program that may provide 
          savings on prescription medications at participating pharmacies. This program cannot be combined 
          with insurance benefits for the same prescription.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>4. Pricing Information</h2>
        <p style={styles.text}>
          Drug prices displayed on our platform are estimates based on data from our partners. Actual prices 
          at the pharmacy may vary. We do not guarantee specific prices or savings. Always confirm the final 
          price with your pharmacist before purchasing.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>5. User Accounts</h2>
        <p style={styles.text}>
          You may create an account to save your preferences and access additional features. You are 
          responsible for maintaining the confidentiality of your account information and for all 
          activities under your account.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>6. Privacy</h2>
        <p style={styles.text}>
          Your use of the Service is subject to our Privacy Policy. By using the Service, you consent 
          to the collection and use of information as described in our Privacy Policy.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>7. Limitation of Liability</h2>
        <p style={styles.text}>
          Rx.ChatWithDr and its affiliates shall not be liable for any indirect, incidental, special, 
          consequential, or punitive damages resulting from your use of the Service. Our total liability 
          shall not exceed the amount you paid to use the Service (if any).
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>8. Changes to Terms</h2>
        <p style={styles.text}>
          We reserve the right to modify these terms at any time. Continued use of the Service after 
          changes constitutes acceptance of the modified terms.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.heading}>9. Contact</h2>
        <p style={styles.text}>
          For questions about these Terms, please contact us at support@chatwithdr.com.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
